import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, select, takeEvery } from 'redux-saga/effects';

import {
  AddVertragToAngebote,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  NavigationRoute,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { WarenkorbAngebot } from '../reducers/produkte.reducer';
import { angebotIsTarifiert } from '../selectors/warenkorb.selector';

export function* updateDashboardGesamtpreisSaga(): SagaIterator {
  yield takeEvery(
    GlobalActions.LOCATION_CHANGED,
    safeSaga(navigationEventReceived, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    GlobalActions.NAVIGATION_COMPLETED,
    safeSaga(navigationEventReceived, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    GlobalActions.PREISE_INS_DASHBOARD_UEBERNEHMEN,
    safeSaga(updateGesamtpreisSaga, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE,
    safeSaga(updateGesamtpreisSaga, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    GlobalActions.PRODUKT_DELETED,
    safeSaga(updateGesamtpreisSaga, App.SHOP_DASHBOARD),
  );
  yield takeEvery(
    GlobalActions.PREISE_RESET_DASHBOARD,
    safeSaga(updateGesamtpreisSaga, App.SHOP_DASHBOARD),
  );
}

export function* navigationEventReceived(action: GlobalAction<NavigationRoute>): SagaIterator {
  if (action.payload.appId !== App.SHOP_DASHBOARD) {
    return yield cancel();
  }

  yield call(updateGesamtpreisSaga, action);
}

export function* updateGesamtpreisSaga(action: AnyAction): SagaIterator {
  if (action.type === GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE) {
    const actionPayload: AddVertragToAngebote = action.payload;
    if (!actionPayload.beibehalten) {
      yield cancel();
    }
  }
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();

  const showGesamtpreisInfo = action.type === GlobalActions.PREISE_INS_DASHBOARD_UEBERNEHMEN;

  yield call(
    globalPut.put,
    new GlobalActions().gesamtpreisChanged(
      calculateGesamtbruttopreis(state.warenkorb),
      showGesamtpreisInfo,
      App.SHOP_DASHBOARD,
      showGesamtpreisInfo ? action.payload?.angebotsId : undefined,
    ),
  );
}

export function calculateGesamtbruttopreis(produkte: Array<WarenkorbAngebot>): number {
  let gesamtbeitrag = 0;
  const selectedProdukte = produkte;
  if (selectedProdukte.length !== 0) {
    selectedProdukte
      .filter(produkt => angebotIsTarifiert(produkt))
      .forEach(produkt => {
        const aktuellerBeitrag = produkt.bruttopreis ? produkt.bruttopreis : 0;
        gesamtbeitrag += aktuellerBeitrag;
      });
  }
  return gesamtbeitrag;
}
